import { ComplianceDocumentType } from "src/utils/documentSeriesEnum";
import { defineForm, MANUAL_DOC_ENDPOINTS } from "../../../../core";
import { vendorPreserve } from "../../../_shared/preserve";
import { PECDestinationFields } from "../components/PECDestinationFields";
import { sdiRegularInvoiceSchema } from "./schema";

export const sdiRegularInvoiceConfig = defineForm({
  id: "sdi_regular_invoice",
  createEndpoint: MANUAL_DOC_ENDPOINTS.SDI_REGULAR_INVOICE,
  permission: "ManualDocumentsIN_Write",
  seriesPermission: "ManualDocumentsSeries_Read",
  documentClass: "Invoice",
  accountClass: "AccountReceivable",
  taxRatesChannel: "SDI",
  invoiceType: "regularInvoice",
  complianceType: ComplianceDocumentType.RegularInvoice,
  requiresLegalRep: true,
  titleKey: "regular_invoice",
  complianceStandardKey: "sdi",
  schema: sdiRegularInvoiceSchema,
  preserveOnReset: vendorPreserve,
  defaults: {
    customerPECCode: "",
    customerDestinationCode: "",
  },
  sections: {
    customer: {
      hiddenFields: ["customerCompanyAddress"],
      extraFields: [
        {
          id: "pec_destination",
          render: ({ translate }) => (
            <PECDestinationFields translate={translate} />
          ),
        },
      ],
      missingChips: [
        { name: "customerPECCode", labelKey: "pec_code_is_missing" },
        { name: "customerDestinationCode", labelKey: "destination_code_is_missing" },
      ],
    },
    additionalOptions: {
      hiddenOptions: ["additionalTax"],
    },
  },
  omitFromPayload: ["customerCompanyAddress"],
});
